import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import createStyles from './styles'

export class Form extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)

    return (
      <form {...this.props} className={css(styles.root)}>
        {this.props.children}
      </form>
    )
  }
}

Form.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles(props => ({
  root: {},
}))



// WEBPACK FOOTER //
// ./src/components/Form.js